import { render, staticRenderFns } from "./allTrain.vue?vue&type=template&id=392212b5&scoped=true&"
import script from "./allTrain.vue?vue&type=script&lang=ts&"
export * from "./allTrain.vue?vue&type=script&lang=ts&"
import style0 from "./allTrain.vue?vue&type=style&index=0&id=392212b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392212b5",
  null
  
)

export default component.exports